import { useEffect } from 'react';

import { ExpirationOptionId } from '../types';

/**
 * Custom hook for managing form submit button state
 * Handles DOM manipulation for form validation based on passkey and date requirements
 */
export const useFormValidation = (
  contextType: string,
  passkey: string,
  isPasskeySectionEnabled: boolean,
  expirationOption: ExpirationOptionId,
  customDate: string
): void => {
  /**
   * Manages form submit button state based on validation rules
   * Disables submit if required fields are missing
   */
  useEffect(() => {
    const updateButtonState = (): void => {
      const submitButton: HTMLInputElement = document.querySelector(
        `.j-submit-${contextType}-privacy-settings input[type="submit"]`
      );

      if (submitButton) {
        const isCustomDateEmptyAndSelected =
          expirationOption === 'custom_date' && !customDate;

        // Disable submit if passkey section is enabled but no passkey, or custom date is selected but empty
        if ((isPasskeySectionEnabled && !passkey) || isCustomDateEmptyAndSelected) {
          submitButton.disabled = true;
          submitButton.classList.add('disabled');
        } else {
          submitButton.disabled = false;
          submitButton.classList.remove('disabled');
        }
      }
    };

    updateButtonState();
  }, [passkey, isPasskeySectionEnabled, expirationOption, customDate, contextType]);
};
